import { render, staticRenderFns } from "./LeBronExquisiteDatabase.vue?vue&type=template&id=4855b4b9&scoped=true"
import script from "./LeBronExquisiteDatabase.vue?vue&type=script&lang=js"
export * from "./LeBronExquisiteDatabase.vue?vue&type=script&lang=js"
import style0 from "./LeBronExquisiteDatabase.vue?vue&type=style&index=0&id=4855b4b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855b4b9",
  null
  
)

export default component.exports